// extracted by mini-css-extract-plugin
export default {"indicatorsOccurrencesTable":"IndicatorsOccurrencesTable_indicatorsOccurrencesTable__IQdeO","likeAnimation":"IndicatorsOccurrencesTable_likeAnimation__nwNlf"};